
import {Component, Prop, Vue} from "vue-property-decorator";
import LoyaltyBonusUpdateForm from "@/form/loyalty/loyaltyBonus/LoyaltyBonusUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup},
})
export default class LoyaltyBonusUpdateFormComponent extends Vue {
  @Prop() form!: LoyaltyBonusUpdateForm;

}
